// AI assisted development

export const UPSHOP_LOADING_COLOR_GRADIENT = '#064651';
export const UPSHOP_LOADING_COLOR_BASE = '#f5f9fa';

export const UPSHOP_LOADING_PATH0 =
	'M11.1211 27.9004C8.41645 27.9003 5.92909 26.8917 4.02246 25.0586C2.11917 23.2288 1.04679 20.7881 1 18.1836L1 14.2031L5.02344 12.8506L5.02344 18.0068C5.02354 19.5761 5.66212 21.0555 6.81738 22.1641C7.96598 23.2691 9.49514 23.8769 11.1211 23.877C12.7472 23.877 14.2233 23.2891 15.3652 22.2207C16.5173 21.1455 17.1714 19.7023 17.2148 18.1562L17.2148 13.6621L21.2422 12.3096L21.2422 18.0068C21.2421 20.648 20.1907 23.1325 18.2842 24.999C16.3708 26.8723 13.8258 27.9004 11.1211 27.9004Z';

export const UPSHOP_LOADING_PATH1 =
	'M9.05762 12.8945C9.05762 10.2532 10.1099 7.76894 12.0166 5.90234C13.93 4.03241 16.474 3 19.1787 3C21.8833 3 24.3707 4.00874 26.2773 5.8418C28.1807 7.67167 29.2531 10.1128 29.2998 12.7207L29.2998 16.6973L29.2969 16.6973L25.2725 18.0498L25.2725 12.8945C25.2725 11.3253 24.6385 9.84586 23.4834 8.7373C22.3347 7.63204 20.8049 7.02344 19.1787 7.02344C17.5526 7.02344 16.0765 7.61126 14.9346 8.67969C13.7826 9.7549 13.1284 11.1981 13.085 12.7441L13.085 17.2383L9.05762 18.5908L9.05762 12.8945Z';

export function encodeUpshopLoadingSvg(svg: string): string {
	return (
		'data:image/svg+xml;utf8,' +
		encodeURIComponent(svg.replace(/\n/g, '').replace(/\s+/g, ' '))
	);
}

export function mixUpshopLoadingColors(color1: string, color2: string, weight: number): string {
	const r1 = parseInt(color1.substring(1, 3), 16);
	const g1 = parseInt(color1.substring(3, 5), 16);
	const b1 = parseInt(color1.substring(5, 7), 16);

	const r2 = parseInt(color2.substring(1, 3), 16);
	const g2 = parseInt(color2.substring(3, 5), 16);
	const b2 = parseInt(color2.substring(5, 7), 16);

	const r = Math.round(r1 * (1 - weight) + r2 * weight);
	const g = Math.round(g1 * (1 - weight) + g2 * weight);
	const b = Math.round(b1 * (1 - weight) + b2 * weight);

	const toHex = (n: number) => {
		const hex = n.toString(16);
		return hex.length === 1 ? '0' + hex : hex;
	};

	return '#' + toHex(r) + toHex(g) + toHex(b);
}

export function generateUpshopLoadingConicGradientSvg(startColor: string, endColor: string): string {
	const segments = 24;
	const center = 50;
	const radius = 100;
	let paths = '';

	for (let i = 0; i < segments; i++) {
		const startAngle = (i / segments) * 360;
		const endAngle = ((i + 1) / segments) * 360;
		const largeArc = endAngle - startAngle > 180 ? 1 : 0;

		const x1 = center + radius * Math.cos((startAngle * Math.PI) / 180);
		const y1 = center + radius * Math.sin((startAngle * Math.PI) / 180);
		const x2 = center + radius * Math.cos((endAngle * Math.PI) / 180);
		const y2 = center + radius * Math.sin((endAngle * Math.PI) / 180);

		const color = mixUpshopLoadingColors(startColor, endColor, i / (segments - 1));

		paths +=
			'<path d="M' +
			center +
			',' +
			center +
			' L' +
			x1 +
			',' +
			y1 +
			' A' +
			radius +
			',' +
			radius +
			' 0 ' +
			largeArc +
			',1 ' +
			x2 +
			',' +
			y2 +
			' Z" fill="' +
			color +
			'" stroke="' +
			color +
			'" stroke-width="1" />';
	}

	return (
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">' +
		paths +
		'</svg>'
	);
}
